import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContextDroitsModel } from '../../models/menu/context-droits.model';
import { LienItemModel } from '../../models/menu/lien-item.model';
import { AutorisationsAggregate } from '../autorisation/autorisations.aggregate';

export class SousMenuItemAggregate {
  isOutsideURL = false;
  constructor(
    readonly libelle: string,
    readonly routerLink: string,
    readonly autorisations?: AutorisationsAggregate,
    readonly iconClass?: string,
  ) {}

  defineAsOutsideURL(): SousMenuItemAggregate {
    this.isOutsideURL = true;
    return this;
  }

  getSousMenuItemWithVisibilityFromContext(
    context: ContextDroitsModel,
  ): Observable<{sousMenu: SousMenuItemAggregate; isVisible: boolean}> {
    if (!this.autorisations) {
      return of({
        sousMenu: this,
        isVisible: true,
      });
    }

    return this.autorisations.isAuthorizedForContext(context).pipe(
      map(isVisible => {
        return {
          sousMenu: this,
          isVisible: isVisible,
        };
      }),
    );
  }

  buildSousMenuItem(): LienItemModel {
    return {
      iconClass: this.iconClass,
      libelle: this.libelle,
      routerLink: this.routerLink,
      isOutsideLink: this.isOutsideURL,
    };
  }
}
